import { render, staticRenderFns } from "./TabReviews.vue?vue&type=template&id=c46fb546"
import script from "./TabReviews.vue?vue&type=script&lang=js"
export * from "./TabReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports